module.exports = __webpack_public_path__ + "img/swiperTwo.ca94095b.png";